export default __webpack_public_path__ + "static/media/Satellite.41a1f7bd.png";